import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    width: 30px;\n    height: 30px;\n    position: absolute;\n    display: flex;\n    z-index: -1;\n    justify-content: center;\n    align-items: center;\n\n    &::before {\n        content: '';\n        box-sizing: border-box;\n        width: 20px;\n        height: 20px;\n        transform: rotate(45deg);\n        display: inline-block;\n        background-color: ", ";\n    }\n\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n            left: ", ";\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            right: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            top: ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            bottom: ", ";\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

function placement(_ref) {
  var placement = _ref.placement;
  var offset = '-11px';

  if (['top', 'top-start', 'top-end'].includes(placement)) {
    return css(_templateObject(), offset);
  }

  if (['bottom', 'bottom-start', 'bottom-end'].includes(placement)) {
    return css(_templateObject2(), offset);
  }

  if (['left', 'left-start', 'left-end'].includes(placement)) {
    return css(_templateObject3(), offset);
  }

  if (['right', 'right-start', 'right-end'].includes(placement)) {
    return css(_templateObject4(), offset);
  }

  return null;
}

var BalloonArrowStyled = styled.i(_templateObject5(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.common.white;
}, placement);
export var BalloonArrow = forwardRef(function (props, ref) {
  return React.createElement(BalloonArrowStyled, Object.assign({}, props, {
    ref: ref
  }));
});
BalloonArrow.displayName = 'BalloonArrow';